import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Navigation } from 'styled-icons/boxicons-solid';
import { Title } from '../../../index';

import * as S from './styled';

export default function Map() {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          contacts {
            map {
              title
            }
          }
        }
      }
      staticMap {
        center
        childFile {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `);

  function onWazeClickHandler() {
    const baseLink = 'https://www.waze.com/ul?navigate=yes&zoom=17';
    const routeLink = `${baseLink}&q=${data.staticMap.center}`;
    window.open(routeLink, '_blank');
  }

  function onMapsClickHandler() {
    const baseLink = 'https://maps.google.com?saddr=Current+Location';
    const routeLink = `${baseLink}&daddr=${data.staticMap.center}`;
    window.open(routeLink, '_blank');
  }

  return (
    <S.Card>
        <S.Map
        title="google-map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.3960996619853!2d-48.0427224!3d-23.5901233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c5cdd67ce1f915%3A0xa453ad1e988e463c!2sDr.%20Rinaldo%20Bianque!5e0!3m2!1spt-BR!2sbr!4v1667666104727!5m2!1spt-BR!2sbr"
        width="600"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      />
      <S.Container>
        <Title>{data.site.siteMetadata.contacts.map.title}</Title>
        <S.Actions>
          <S.Action onClick={onWazeClickHandler}>
            <Navigation size={20} />
            Waze
          </S.Action>
          <S.Action onClick={onMapsClickHandler}>
            <Navigation size={20} />
            Google Maps
          </S.Action>
        </S.Actions>
      </S.Container>
    </S.Card>
  );
}
